import React, { useState } from "react";
import { Formik } from "formik";
import { injectIntl } from "react-intl";
import md5 from "js-md5";

import {
  backendShape,
  List,
  Loader,
  intlShape,
  Row,
  Column,
  notifierShape,
  withBackend,
  accessRightsShape,
  withNotifier,
  ButtonGroup,
  Form,
  SubmitButton,
  TextInput,
} from "lcm-iot-commons";

import OpcUaServerWhitelistItem from "./OpcUaServerWhitelistItem";

type Props = {
  intl: intlShape;
  opcUaServer: {
    id?: string;
    subscription_id?: string;
  };
  accessRights: accessRightsShape;
  notifier: notifierShape;
  backend: backendShape;
};

export function OpcUaServerWhitelist({
  intl,
  opcUaServer,
  notifier,
  accessRights,
  backend,
}: Props) {
  const [whitelist, setWhitelist] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [fetching, setFechting] = useState(false);

  const loadWhitelist = async () => {
    try {
      const response = await backend.get(
        `/api_subscriptions/${opcUaServer.subscription_id}/opc_ua_servers/${opcUaServer.id}/whitelist`,
      );
      setWhitelist(response);
    } catch (error) {
      notifier.showError(backend.translateError(error));
    }
    setIsLoading(false);
  };

  React.useEffect(() => {
    loadWhitelist();
  }, [opcUaServer]);

  const handleOnDelete = async (id: $TSFixMe) => {
    setFechting(true);
    try {
      await backend.delete(
        `/api_subscriptions/${opcUaServer.subscription_id}/opc_ua_servers/${opcUaServer.id}/whitelist/${id}`,
      );
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      setWhitelist(whitelist.filter((i: $TSFixMe) => i.id !== id));
      notifier.showSuccess(
        intl.formatMessage({ id: "whitelist_item.delete.notification" }),
      );
    } catch (error) {
      notifier.showError(backend.translateError(error));
    }
    setFechting(false);
  };

  const handleOnSubmit = async (values: $TSFixMe, actions: $TSFixMe) => {
    setFechting(true);
    try {
      await backend.post(
        `/api_subscriptions/${opcUaServer.subscription_id}/opc_ua_servers/${opcUaServer.id}/whitelist`,
        values,
      );
      // @ts-expect-error TS(2345) FIXME: Argument of type 'any[]' is not assignable to para... Remove this comment to see the full error message
      setWhitelist([...whitelist, { id: md5(values.name), name: values.name }]);
      notifier.showSuccess(
        intl.formatMessage({ id: "whitelist_item.added.notification" }),
      );
    } catch (error) {
      notifier.showError(backend.translateError(error));
    }
    actions.setSubmitting(false);
    actions.resetForm({ values: {} });
    setFechting(false);
  };

  const validate = (values: $TSFixMe) => {
    const errors = {};

    if (!values.name || values.name.trim().length === 0) {
      (errors as $TSFixMe).name = intl.formatMessage({
        id: "whitelist_item.error.invalid",
      });
    } else if (values.name === "default") {
      (errors as $TSFixMe).name = intl.formatMessage({
        id: "whitelist_item.error.default",
      });
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    } else if (whitelist.find((v: $TSFixMe) => v.name === values.name.trim())) {
      (errors as $TSFixMe).name = intl.formatMessage({
        id: "whitelist_item.error.exists",
      });
    }

    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;
    return (
      <Form {...formProps}>
        <TextInput
          {...formProps}
          id="name"
          name="name"
          label={intl.formatMessage({ id: "label.common_name" })}
          disabled={isLoading || isSubmitting || fetching}
          hideLabel
        />
        <ButtonGroup>
          <SubmitButton
            id="add-whitelist-entry-button"
            fetching={isSubmitting}
            disabled={isLoading || isSubmitting || fetching}
            text={intl.formatMessage({ id: "button.add" })}
          />
        </ButtonGroup>
        <div className="space-after" />
      </Form>
    );
  };

  return (
    <Loader loading={isLoading}>
      <Row>
        <Column>
          {accessRights.canUpdate && (
            <Formik
              onSubmit={handleOnSubmit}
              initialValues={{}}
              validate={validate}
            >
              {renderForm}
            </Formik>
          )}
        </Column>
      </Row>
      <Row>
        <Column>
          {whitelist && (whitelist as $TSFixMe).length > 0 && (
            <List>
              {(whitelist as $TSFixMe).map((item: $TSFixMe) => (
                <OpcUaServerWhitelistItem
                  key={item.id}
                  disabled={fetching}
                  onDelete={handleOnDelete}
                  accessRights={accessRights}
                  item={item}
                />
              ))}
            </List>
          )}
          {whitelist && (whitelist as $TSFixMe).length === 0 && (
            <p id="empty-whitelist-message" className="space-after">
              {intl.formatMessage({ id: "opc_ua_server_details.no_whitelist" })}
            </p>
          )}
        </Column>
      </Row>
    </Loader>
  );
}

export default injectIntl(withNotifier(withBackend(OpcUaServerWhitelist)));
